export default __webpack_public_path__ + "static/media/BWP ZOO WEB ICON Lion house CY.b4dddf01.png";